import { Component } from 'nuxt-property-decorator'
import { BaseVue } from './BaseVue'

@Component
export class ModalComponentBaseVue extends BaseVue {
  calculateTableHeightBase(adjustedValue: number = 48): number {
    const modalElements = document.querySelectorAll<HTMLElement>(
      '.v-dialog__content--active'
    )
    if (modalElements.length === 0) return 0

    let activeIndex = 0
    let maxZIndex = 0
    modalElements.forEach((el, index) => {
      const zIndex = el.style.zIndex === '' ? 0 : Number(el.style.zIndex)
      if (zIndex > maxZIndex) {
        activeIndex = index
        maxZIndex = zIndex
      }
    })

    const activeElement = modalElements[activeIndex].querySelector<HTMLElement>(
      '.v-dialog--active'
    )
    if (activeElement == null) return 0

    return window.innerHeight - (activeElement.clientHeight + adjustedValue)
  }
}
